export default "__VITE_ASSET__Cb60CNZx__"